<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{path: '/bonddb/bondlist'}">债券管理</el-breadcrumb-item>
				<el-breadcrumb-item>债券编辑</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div style="width: 100%;justify-content: center;display: flex;">
			<el-form class="user-search" :model="editForm" label-width="130px" inline label-position="left"
				:rules="rules" ref="editForm" size="small">
				<div class="title-contain">基本条款</div>
				<el-divider></el-divider>
                <el-form-item label="债券代码：" prop="bondCode">
					<el-input size="small" placeholder="请输入债券代码" v-model="editForm.bondCode">
					</el-input>
				</el-form-item>
				<el-form-item label="债券简称：" prop="bondName">
					<el-input size="small" placeholder="请输入债券简称" v-model="editForm.bondName">
					</el-input>
				</el-form-item>
				<el-form-item label="债券全称：" prop="bondFullName">
					<el-input size="small" placeholder="请输入商品名称" v-model="editForm.bondFullName">
					</el-input>
				</el-form-item>
				<el-form-item label="当前余额(亿)：" prop="balance">
					<el-input size="small" placeholder="请输入当前余额" v-model="editForm.balance">
					</el-input>
				</el-form-item>
                <el-form-item label="票面利率[%]：" prop="rate">
					<el-input size="small" placeholder="请输入票面利率" v-model="editForm.rate">
					</el-input>
				</el-form-item>
                <el-form-item label="发行价格[元]：" prop="issuePrice">
					<el-input size="small" placeholder="请输入发行价格" v-model="editForm.issuePrice">
					</el-input>
				</el-form-item>
				<el-form-item label="债券类型：" prop="bondType">
                    <el-select v-model="editForm.bondType" placeholder="请选择债券类型" clearable>
                        <el-option :label="item" :value="item" v-for="item in bondTypes" :key="item"></el-option>
				    </el-select>
				</el-form-item>
                <el-form-item label="债券市场：" prop="market">
                    <el-select v-model="editForm.market" placeholder="请选择债券市场" clearable>
					    <el-option :label="item" :value="item" v-for="item in markets" :key="item"></el-option>
				    </el-select>
				</el-form-item>
                

                <el-form-item label="利率类型：" prop="rateType">
                    <el-select v-model="editForm.rateType" placeholder="请选择利率类型" clearable>
				    <el-option :label="item" :value="item" v-for="item in rateTypes" :key="item"></el-option>
				    </el-select>
				</el-form-item>
                <el-form-item label="起息日期：">
					<el-date-picker v-model="editForm.bondStartTime" catename="presaleTime" value-format="yyyy-MM-dd" type="date"></el-date-picker>
				</el-form-item>
                <el-form-item label="到期日期：">
					<el-date-picker v-model="editForm.endDate" catename="presaleTime" value-format="yyyy-MM-dd" type="date"></el-date-picker>
				</el-form-item>
                <el-form-item label="上市时间：">
					<el-date-picker v-model="editForm.listDate" catename="presaleTime" value-format="yyyy-MM-dd" type="date"></el-date-picker>
				</el-form-item>
                <el-form-item label="摘牌时间：">
					<el-date-picker v-model="editForm.delistDate" catename="presaleTime" value-format="yyyy-MM-dd" type="date"></el-date-picker>
				</el-form-item>
				<el-form-item label="付息频率：" prop="rateTimesYear">
					<el-input size="small" placeholder="请输入每年付息次数" v-model="editForm.rateTimesYear">
					</el-input>
				</el-form-item>
				<el-form-item label="期限[年]：">
					<el-input size="small" placeholder="请输入期限" v-model="editForm.bondTerm"></el-input>
				</el-form-item>
                <el-form-item label="计息基准：">
                    <el-select v-model="editForm.rateBase" placeholder="请选择计息基准" clearable>
					    <el-option :label="item" :value="item" v-for="item in rateBases" :key="item"></el-option>
    			    </el-select>
				</el-form-item>

                <el-form-item label="发行方式：" prop="issueType">
                    <el-select v-model="editForm.issueType" placeholder="请选择发行方式" clearable>
                        <el-option :label="item" :value="item" v-for="item in issueTypes" :key="item"></el-option>
                    </el-select>
				</el-form-item>
                <el-form-item label="发行人：">
					<el-input size="small" placeholder="请输入发行人" v-model="editForm.issuer"></el-input>
				</el-form-item>
                <el-form-item label="托管机构：">
					<el-input size="small" placeholder="请输入托管机构" v-model="editForm.trusteeshipInstitution"></el-input>
				</el-form-item>
                <el-form-item label="缴款日期：">
					<el-date-picker v-model="editForm.payDate" catename="presaleTime" value-format="yyyy-MM-dd" type="date"></el-date-picker>
				</el-form-item>
			
				<div class="title-contain">募集发行</div>
				<el-divider></el-divider>
				<el-form-item label="发行开始日期：">
					<el-date-picker v-model="editForm.issueStartTime" catename="presaleTime" value-format="yyyy-MM-dd" type="date"></el-date-picker>
				</el-form-item>
				<el-form-item label="发行截止日期：">
					<el-date-picker v-model="editForm.issueEndTime" catename="groundTime" value-format="yyyy-MM-dd" type="date"></el-date-picker>
				</el-form-item>
                <el-form-item label="发行公告日期：">
					<el-date-picker v-model="editForm.issuePublishTime" catename="groundTime" value-format="yyyy-MM-dd" type="date"></el-date-picker>
				</el-form-item>
				<el-form-item label="计划发行量：" prop="issueVolumePlan">
					<el-input size="small" placeholder="请输入计划发行量" v-model="editForm.issueVolumePlan" style="width: 180px;">
					</el-input><span style="font-size: 12px;">亿</span>
				</el-form-item>
				<el-form-item label="实际发行量" prop="issueVolumeReal">
					<el-input size="small" placeholder="请输入实际发行量" v-model="editForm.issueVolumeReal" style="width: 180px;">
					</el-input><span style="font-size: 12px;">亿</span>
				</el-form-item>

                <el-form-item label="承销方式：" prop="saleType">
					<el-select v-model="editForm.saleType" placeholder="请选择承销方式" size="small" @change="chooseShow1"
						clearable>
						<div v-for="(item,index) in cateMaList" :key="index">
							<el-option :label="item.catename" :value="item.cateid" v-if="item.type=='goods'">
							</el-option>
						</div>
					</el-select>
				</el-form-item>

				<div class="title-contain">说明描述</div>
				<el-divider></el-divider>
				<quill-edit @content="getContent" :width="1000" :height="800" :des="editForm.des"></quill-edit>
			</el-form>

		</div>
		<div class="footer" style="width: 1000px;">
			<el-button @click="closeDialog" size="medium ">返回</el-button>
			<el-button type="primary" :loading="loading" @click="submitreplyForm('editForm')"
				size="medium ">保存
			</el-button>
		</div>

	</div>
</template>

<script>
	import quillEdit from '../../components/quillEdit'
	import {
		addEditBondBase,
		// getSaleGoods,
		getGoodsCategoryByParent,
		getBondBaseById,

        getBondCateLevel2By1
	} from '../../api/basisMG.js'
	// import uploadMore from '../../components/uploadMore'

	import ruleMixin from '@/utils/ruleMixin'
	// 导出模块
	export default {
		mixins: [ruleMixin],
		components: {
			quillEdit,
			//uploadMore
		},
		// 模块数据
		data() {
			//数据  
			return {
                bondTypes:[],
                markets:[],
                rateTypes:[],
                rateBases:[],
                issueTypes:[],

				isGwSale: 1,
				single: 'single',
				twin: 'twin',
				goodsvalue: [],
				topRecommendationGoodsIds: [],
				bottomRecommendationGoodsIds: [],
				allGoodList: [],
				value1: [],
				tableData: [],
				// 第一个分类
				cateMaList: [],
				// 展示类别
				showCategoryList: [],
				goodstypeList: [],
				goodsmaterialList: [],
				cateMaterialId: null,
				// 选中的对象
				chooseobj: {},
				oldcateMainId: '',
				value: [],
				loading: false,
				Visible: false,
				fileList: [],
				dialogImageUrl: '',
				dialogVisible: false,
				editForm: {
					isSale: 0,
					goodsId: '',
					goodstype: '',
					goodsName: '',
					des: '',
					SelectValue: '',
					goodsdes: '',
					sellPoint: '',
					specications: '',
					price: null,
					marketPrice: null,
					stock: 999,
					saleNum: 0,
					purchaseLimit: 0,
					day: '',
					time: '',
					imglunbo: '',
					videoUrl: '',
					videoImg: '',
					mainImg: '',
					indexImg: '',
					freightFee: '',
					cateId: null,
					cateId2: null,
					stockThresholdType: null,
					stockThreshold: 100,
					uploadData: [],
					allGoodList: [],
					formInline: {},
					pageparm: {},
					isWebImg: 'no'
				}
			}
		},


		watch: {},

		methods: {
			// 获得在售商品
			// getGoods() {
			// 	getSaleGoods().then(res => {
			// 		if (res.code == '200') {
			// 			this.allGoodList = res.data
			// 		}
			// 	})
			// },
			getdata(data, catename) {
				this.editForm[catename] = data

			},
			catetransfer(data) {

				this.editForm.relationRecommendGoods = data.join(",")
			},
			cateSelect(data) {
				let length = data.length
				this.editForm.cateId = data[length - 1]

			},
			cate2Select(data) {
				let length = data.length
				this.editForm.cateId2 = data[length - 1]
			},
			handleExceed(files, fileList) {
				this.$message.warning(
					`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			//  图片上传
			handleRemove(file, fileList) {
				// this.editForm.fileList = fileList
				this.fileList = fileList
				let arr = []
				if(this.fileList.length){
					this.fileList.forEach(item => {
					arr.push(item.response.data)
				})
				}
				
				if (arr.length) {
					this.editForm.bannerImg = arr.join(",")
				} else {
					this.editForm.bannerImg = ""
				}

			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			handleSuccess(response, file, fileList) {

				this.fileList = fileList
				let arr = []
				this.fileList.forEach(item => {
					arr.push(item.response.data)
				})

				this.editForm.bannerImg = arr.join(",")
				this.dialogImageUrl = response.data


			},
			timeChange(time) {
				this.editForm.seckillStarttime = time

			},
			handleScroll() {
				let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
				scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
			},

			submitreplyForm(formName) {
				let that = this
				console.log(this.editForm)
				this.$refs[formName].validate((valid, object) => {
					console.log(valid)
					if (valid) {

						this.editForm.topRecommendationGoodsIds = this.topRecommendationGoodsIds.join(",")
						this.editForm.bottomRecommendationGoodsIds = this.bottomRecommendationGoodsIds.join(",")
						that.editForm.goodsType = "normal"
						// if(this.editForm.cateMaId != 12){
						// 	this.editForm.experienceDay = 0
						// 	this.editForm.experienceMoney = 0
						// }
						addEditBondBase(that.editForm).then(res => {
							if (res.code == '200') {
								that.$router.push({
									path: '/bonddb/bondlist',
									query: {
										formInline: this.formInline,
										pageparm: this.pageparm
									}
								})
							}
						})
					} else {
						console.log(object)
						this.$message.error('您还有必填的未填，请核对')
						that.handleScroll()
					}
				})

			},

			// 单个上传图
			uploadone(data, cateName) {
				this.editForm[cateName] = data
			},

			getContent(content) {
				this.editForm.des = content
			},
			selectChange(val) {
				console.log(val)
				this.editForm.cateTypeName = ''
				this.chooseobj.goodstypeList.forEach(item => {
					if (item.cateid == val) {
						this.editForm.cateTypeName = item.catename
					}
				})

				this.$forceUpdate()
			},
			selectChangeMa(val) {
				this.editForm.cateMaterialName = ''
				this.chooseobj.goodsmaterialList.forEach(item => {
					if (item.cateid == val) {
						this.editForm.cateMaterialName = item.catename
					}
				})
				this.$forceUpdate()
			},

			// 选择展示类别
			chooseShow1(val) {
				if (val) {
					let chooseobj = this.cateMaList.find(item => {
						return val == item.cateid
					})
					// this.cateMaId = val
					this.editForm.cateMaName = chooseobj.catename
					// this.editForm.cateMaId = val
					this.editForm.cateMainId = null
					this.editForm.cateMaterialId = null
					this.editForm.cateTypeId = null
					this.geshowCategoryListByParent(val)
					this.$forceUpdate()
				} else {
					this.chooseobj = {}
					this.editForm.cateMainName = null
					this.editForm.cateMaterialId = null
					this.editForm.cateTypeId = null
					this.$forceUpdate()
				}
			},

			chooseShow2(val) {
				if (val) {
					let chooseobj = this.showCategoryList.find(item => {
						return val == item.cateid
					})
					console.log('chooseShow2', chooseobj)
					this.editForm.cateMainName = chooseobj.catename
					this.editForm.cateMainId = val
					this.editForm.cateMaterialId = null
					this.editForm.cateTypeId = null
					this.getMaTypeByParent(val)
					this.$forceUpdate()

				} else {
					this.chooseobj = {}
					this.editForm.cateMainName = null
					this.editForm.cateMaterialId = null
					this.editForm.cateTypeId = null
					this.$forceUpdate()
				}

			},
			// 选择展示类别
			chooseShow3(val) {
				console.log('chooseShow3', val)
				if (val) {
					let chooseobj = this.goodsmaterialList.find(item => {
						return val == item.cateid
					})
					this.editForm.cateMaterialName = chooseobj.catename

					this.$forceUpdate()
				}
			},
			// 选择展示类别
			chooseShow4(val) {
				console.log('chooseShow4', val)
				if (val) {
					let chooseobj = this.goodstypeList.find(item => {
						return val == item.cateid
					})
					this.editForm.cateTypeName = chooseobj.catename
					this.$forceUpdate()
				} else {
					this.$forceUpdate()
				}

			},
			getGoodsCategoryByParent(cateid) {
				getGoodsCategoryByParent({cateid}).then(res => {
					console.log(res)
					if (cateid == 0) {
						this.cateMaList = res.data
					}
				})
			},
            
			geshowCategoryListByParent(cateid) {
				getGoodsCategoryByParent({cateid}).then(res => {
					if (res.code == 200) {
						this.showCategoryList = res.data
					}
				})
			},
            getBondCateLevel2ByLevel1(catenameLevel1){
                getBondCateLevel2By1({catenameLevel1:catenameLevel1}).then(res => {
					if (res.code == 200) {
                        switch (catenameLevel1) {
                            case '债券类型':this.bondTypes = res.data;break;
                            case '交易市场':this.markets = res.data;break;
                            case '利率类型':this.rateTypes = res.data;break;
                            case '计息基准':this.rateBases = res.data;break;
                            case '发行方式':this.issueTypes = res.data;break; 
                            default:break;
                        }
						
					}
				})
            },
			getMaTypeByParent(cateid) {
				this.goodstypeList = []
				this.goodsmaterialList = []
				getGoodsCategoryByParent({cateid}).then(res => {
					console.log(res)
					if (res.code == 200) {
						let list = res.data
						console.log('getMaTypeByParent', list)
						list.forEach(item => {
							if (item.type == 'goodstype') {
								this.goodstypeList.push(item)
							} else if (item.type == 'goodsmaterial') {
								this.goodsmaterialList.push(item)
							}
						})
						console.log(this.goodstypeList, this.goodsmaterialList)
					}

				})
			},

			formateChildren(data) {
				if (data.length) {
					data.map(element => {
						if (element.children && element.children.length > 0) {
							this.formateChildren(element.children)
						} else {
							delete element.children
						}
					});
				}
				return data
			},

			// 评论框
			closeDialog() {
				this.$router.push({
					path: '/bonddb/bondlist',
					query: {
						formInline: this.formInline,
						pageparm: this.pageparm
					}
				})
			},
			setStatus(row) {
				this.editForm.isSale = row.isSale == 1 ? 0 : 1
			},
			cancel() {

				this.$router.push({
					path: '/bonddb/bondlist',
					query: {
						formInline: this.formInline,
						pageparm: this.pageparm
					}
				})
			},
		},
		// 创建前状态(里面是操作)
		beforeCreate() {},
		// 创建完毕状态(里面是操作)
		async created() {
            this.getBondCateLevel2ByLevel1('债券类型')
            this.getBondCateLevel2ByLevel1('交易市场')
            this.getBondCateLevel2ByLevel1('利率类型')
            this.getBondCateLevel2ByLevel1('计息基准')
            this.getBondCateLevel2ByLevel1('发行方式')
            
            
			// this.getGoods()
			// this.getGoodsCategoryByParent(0)
console.log('this.$route.query',this.$route.query)
			let edit = this.getEditParams(this.$route.path)
			if (edit && edit.goodsId && this.$route.methods =="add") {
				let editForm = edit
				this.saveParams(this.$route.path,editForm)
				let res = await getBondBaseById({
					id: editForm.id
				})
				this.editForm = res.data
			
				console.log(this.editForm)

				// if (this.editForm.cateMaId) {
				// 	this.editForm.cateMaId = parseInt(this.editForm.cateMaId)
				// 	this.geshowCategoryListByParent(this.editForm.cateMaId)
				// }
				if (this.editForm.cateMainId) {
					this.editForm.cateMainId = parseInt(this.editForm.cateMainId)
					this.getMaTypeByParent(this.editForm.cateMainId)
				}
				if (this.editForm.cateMaterialId) {
					this.editForm.cateMaterialId = parseInt(this.editForm.cateMaterialId)
				}
				if (this.editForm.cateTypeId) {
					this.editForm.cateTypeId = parseInt(this.editForm.cateTypeId)
				}
				if (this.editForm.relationRecommendGoods) {
					let goodsvalue = this.editForm.relationRecommendGoods.split(",")
					goodsvalue.forEach(item => {
						this.goodsvalue.push(Number(item))
					})
				}
				// topRecommendationGoodsIds
				if (this.editForm.topRecommendationGoodsIds) {
					let topRecommend = this.editForm.topRecommendationGoodsIds.split(",")
					topRecommend.forEach(item => {
						this.topRecommendationGoodsIds.push(Number(item))
					})
				}
				// bottomRecommendationGoodsIds
				if (this.editForm.bottomRecommendationGoodsIds) {
					let bottomRecommend = this.editForm.bottomRecommendationGoodsIds.split(",")
					bottomRecommend.forEach(item => {
						this.bottomRecommendationGoodsIds.push(Number(item))
					})
				}
				if (this.editForm.bannerImg) {
					let fileList = this.editForm.fileList
					if(fileList&&fileList.length){
						fileList.forEach(item => {
						this.fileList.push(this.web.obj(item))
					})
					}
				}
				if (this.editForm.cateId) {
					this.value.push(Number(this.editForm.cateId))
				}
				if (this.editForm.cateId2) {
					this.value.push(Number(this.editForm.cateId2))
				}
			}
		},
		// 挂载前状态(里面是操作)
		async mounted() {
			if (window.history && window.history.pushState) {
				history.pushState(null, null, document.URL);
				window.addEventListener('popstate', this.cancel, false);
			}

			if (this.$route.query && this.$route.query.formInline) {
				this.formInline = this.$route.query.formInline
				console.log('this.formInline edit', this.formInline)
			}
			if (this.$route.query && this.$route.query.pageparm) {
				this.pageparm = this.$route.query.pageparm
			}
			if (this.$route.query && this.$route.query.editForm) {
				let editForm = JSON.parse(this.$route.query.editForm)
				this.saveParams(this.$route.path,editForm)
				let res = await getBondBaseById({
					id: editForm.id
				})
				this.editForm = res.data
			
				console.log(this.editForm)

				// if (this.editForm.cateMaId) {
				// 	this.editForm.cateMaId = parseInt(this.editForm.cateMaId)
				// 	this.geshowCategoryListByParent(this.editForm.cateMaId)
				// }
				if (this.editForm.cateMainId) {
					this.editForm.cateMainId = parseInt(this.editForm.cateMainId)
					this.getMaTypeByParent(this.editForm.cateMainId)
				}
				if (this.editForm.cateMaterialId) {
					this.editForm.cateMaterialId = parseInt(this.editForm.cateMaterialId)
				}
				if (this.editForm.cateTypeId) {
					this.editForm.cateTypeId = parseInt(this.editForm.cateTypeId)
				}
				if (this.editForm.relationRecommendGoods) {
					let goodsvalue = this.editForm.relationRecommendGoods.split(",")

					goodsvalue.forEach(item => {
						this.goodsvalue.push(Number(item))
					})
				}
				// topRecommendationGoodsIds
				if (this.editForm.topRecommendationGoodsIds) {
					let topRecommend = this.editForm.topRecommendationGoodsIds.split(",")

					topRecommend.forEach(item => {
						this.topRecommendationGoodsIds.push(Number(item))
					})
				}
				// bottomRecommendationGoodsIds
				if (this.editForm.bottomRecommendationGoodsIds) {
					let bottomRecommend = this.editForm.bottomRecommendationGoodsIds.split(",")

					bottomRecommend.forEach(item => {
						this.bottomRecommendationGoodsIds.push(Number(item))
					})
				}
				if (this.editForm.bannerImg) {

					let fileList = this.editForm.fileList
					if(fileList&&fileList.length){
						fileList.forEach(item => {
						this.fileList.push(this.web.obj(item))
					})
					}
					
				}
				if (this.editForm.cateId) {
					this.value.push(Number(this.editForm.cateId))
				}

				if (this.editForm.cateId2) {
					this.value.push(Number(this.editForm.cateId2))
				}
			}
		},
		beforeUpdate() {},
		updated() {},
		beforeDestroy() {},
		destroyed() {
			window.removeEventListener('popstate', this.cancel, false)
		}
	};
</script>

<style scoped>
	.el-form-item {
		width: 31%;

	}

	.title-contain {
		font-weight: 500;
		font-size: 20px;
		margin-top: 30px;
	}

	.just-start {
		display: flex;
		justify-content: flex-start;
	}

	.marginT20 {
		margin-top: 20px;
	}

	.footer {
		margin: 100px 0;

		display: flex;
		justify-content: center;
	}
</style>
